import React, { useEffect } from 'react';
import { Button } from '@zurich-primitives/button';
import { Modal } from '@zurich-base-ui/components.modal';
import {
  getIsSelectLanguageModal,
  setSelectedLanguage,
  useAppSelector
} from 'app/redux';
import styles from './LanguageSelector.module.scss';
import languages from 'data/mock/languages.json';
import { ReactComponent as AttachIcon } from 'app/assets/Icons/AttachWhite.svg';

import { useDispatch } from 'react-redux';

const LanguageSelector: React.FC<{
  onSelectLanguageModal: (e: { stopPropagation: () => void }) => void;
}> = ({ onSelectLanguageModal }) => {
  const dispatch = useDispatch();
  const isSelectLanguageModal = useAppSelector(getIsSelectLanguageModal);

  useEffect(() => {
    dispatch(setSelectedLanguage('english'));
  }, []);

  return (
    <Modal
      on={isSelectLanguageModal}
      onClose={onSelectLanguageModal}
      variant="slim"
    >
      <div className={`${styles.modal} p-8 pt-6`}>
        <h2 className="f-data-blue highlight">
          Select the language
          <br />
          for the answer
        </h2>
        <select
          id="languageSelect"
          className={styles['select-element']}
          onChange={(e) =>
            dispatch(
              setSelectedLanguage(String(e.target.value).toLocaleLowerCase())
            )
          }
        >
          {languages.map((language) => (
            <option key={language.name} value={language.name}>
              {language.name}
            </option>
          ))}
        </select>

        <p className="caption-lg-r">
          Please specify your preferred language for the response, and after,
          upload the file for a summarized review of its contents.
        </p>

        <Button onClick={onSelectLanguageModal} className={styles['ok-btn']}>
          <Button.Icon>
            <AttachIcon />
          </Button.Icon>
          <Button.Label>Upload File</Button.Label>
        </Button>
      </div>
    </Modal>
  );
};

export default LanguageSelector;
